/**
 * Deploy Configuration Validation Schema — Lotto 1
 *
 * Schema Zod per la validazione della configurazione deploy.
 * Condiviso tra backend (API validation) e frontend (form validation).
 */
import { z } from 'zod';
// === Regex patterns per validazione formati ===
// Duration: 30s, 5m, 2h, 7d
const durationRegex = /^\d+[smhd]$/;
// Nginx rate limit: 30r/s, 10r/m
const nginxRateLimitRegex = /^\d+r\/[sm]$/;
// Memory size Docker: 128M, 1G, 512K
const memorySizeRegex = /^\d+[KMG]$/;
// Cron format: "0 2 * * *" (5 fields, supports *, numbers, ranges, steps, lists)
// Validates: numbers, wildcards (*), ranges (1-5), steps (*/15), lists (1,2,3)
const cronField = '[0-9*,/-]+';
const cronRegex = new RegExp(`^${cronField}\\s+${cronField}\\s+${cronField}\\s+${cronField}\\s+${cronField}$`);
/**
 * Schema Zod per DeployConfigLotto1
 * Tutti i campi sono optional — se undefined, viene usato il default.
 */
export const deployConfigSchemaLotto1 = z.object({
    // === 1. AMBIENTE ===
    environment: z.enum(['production', 'staging', 'development']).optional(),
    baseUrl: z.string().url('URL non valido').optional(),
    webPort: z.number().int().min(1).max(65535).optional(),
    timezone: z.string().optional(), // IANA timezone: Europe/Rome
    // === 2. RISORSE DOCKER ===
    docker: z.object({
        nginx: z.object({
            memoryLimit: z.string().regex(memorySizeRegex, 'Formato: 128M, 1G').optional(),
        }).strict().optional(),
        backend: z.object({
            memoryLimit: z.string().regex(memorySizeRegex, 'Formato: 512M, 2G').optional(),
        }).strict().optional(),
        logMaxSize: z.string().regex(memorySizeRegex, 'Formato: 10M, 50M').optional(),
        logMaxFiles: z.number().int().min(1).max(20).optional(),
    }).strict().optional(),
    // === 3. SICUREZZA ===
    security: z.object({
        rateLimitApi: z.string().regex(nginxRateLimitRegex, 'Formato: 30r/s, 10r/m').optional(),
        rateLimitDeploy: z.string().regex(nginxRateLimitRegex, 'Formato: 2r/m').optional(),
        clientMaxBodySize: z.string().regex(memorySizeRegex, 'Formato: 5M, 10M').optional(),
    }).strict().optional(),
    // === 4. NGINX ===
    nginx: z.object({
        gzipCompressionLevel: z.number().int().min(1).max(9).optional(),
        proxyConnectTimeout: z.string().regex(durationRegex, 'Formato: 10s, 30s').optional(),
        proxyReadTimeout: z.string().regex(durationRegex, 'Formato: 30s, 60s').optional(),
    }).strict().optional(),
    // === 5. BACKUP ===
    backup: z.object({
        enabled: z.boolean().optional(),
        schedule: z.string().regex(cronRegex, 'Cron format: 0 2 * * *').optional(),
        retentionDays: z.number().int().min(1).max(365).optional(),
        includeUploads: z.boolean().optional(),
        compressUploads: z.boolean().optional(),
    }).strict().optional(),
}).strict(); // strict = non permette campi extra
// === Alias per compatibilità futura ===
export const deployConfigSchema = deployConfigSchemaLotto1;
//# sourceMappingURL=deploy-config.schema.js.map